import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { zustandSessionConfigStorageName } from 'src/utils/cookieHelper';
import useStore from './useStore';

interface State {
  setIsNewSession: (value: boolean) => void;
  isNewSession: boolean;
}

const useSessionConfigStore = create<State>()(
  persist(
    (set) => ({
      setIsNewSession: (value) => {
        set({ isNewSession: value });
      },
      isNewSession: true
    }),
    {
      name: zustandSessionConfigStorageName,
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

const fallbackStore: State = {
  setIsNewSession: () => null,
  isNewSession: true
};

export default () =>
  useStore<State>(useSessionConfigStore, (state) => state) ?? fallbackStore;
